import { Box, MenuItem, TextField } from '@mui/material';

interface SwiftFlowErrorsFiltersProps {
    searchTerm: string;
    gatewayFilter: string;
    gateways: string[];
    onSearchChange: (value: string) => void;
    onGatewayChange: (value: string) => void;
}

export function SwiftFlowErrorsFilters({
    searchTerm,
    gatewayFilter,
    gateways,
    onSearchChange,
    onGatewayChange,
}: SwiftFlowErrorsFiltersProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                mb: 2,
            }}
        >
            <TextField
                label="Search by code or original message"
                size="small"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                sx={{ minWidth: 260, flex: 1 }}
            />
            <TextField
                label="Gateway"
                select
                size="small"
                value={gatewayFilter}
                onChange={(e) => onGatewayChange(e.target.value)}
                sx={{ minWidth: 180 }}
            >
                <MenuItem value="all">All Gateways</MenuItem>
                {gateways.map((g) => (
                    <MenuItem key={g} value={g}>
                        {g}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
}
